import styled from "styled-components";

export const StyledCoordsLink = styled.a`
    width: auto;
    max-width: 100%;
`;
